import { ApiLoadingStatus } from "enum/api-loading-status.enum";
import { IVirtualWarehousesSlice } from "./VirtualWarehousesSlice.interface";

export const VirtualWarehousesSliceInitialSlice: IVirtualWarehousesSlice = {
  loadingStatus: ApiLoadingStatus.IDLE,
  items: [],
};
